import {dataGroupStore, DataGroupStore} from 'common/report/stores/data-groups';
import {contextify, createLegacyStoreContextHook, createRootContextHook} from 'common/util/react';

const context = contextify<DataGroupStore>();

export const DataGroupProvider = context.Provider;
export const DataGroupConsumer = context.Consumer;
export const useDataGroups = createLegacyStoreContextHook(dataGroupStore);

export const useDataGroupsReact = createRootContextHook(`dataGroups`);
